module.exports = __webpack_public_path__ + "img/fundomob.2623eac4.webp";